module.exports = __webpack_public_path__ + "static/media/phishing.f3b50b39.png";